import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser'; 
import { FormattedMessage } from 'react-intl';
import { Image, Link } from 'components';
import { routes } from 'utils/routes';
import { media } from 'utils/media';

const Hero = ({ content }) => {
  if(!content.headerEnabled) return false; 
  return (
    <section className="header">
      <div className='cover-home fvw'>
        <div className='cover content-wrapper'>
          <Image url={media(content.headerImage)} alt={content.headerAlt} className='section-media' />
          <div className='section-text'>
            <h1>{ReactHtmlParser(content.headerTitle)}</h1>
            <p className='mt-20'>{ReactHtmlParser(content.headerSubtitle)}</p>
            <div className='flex-vam cover-home-actions'>
              <Link to={routes.getStarted.path} {...routes.getStarted} className='button'>{content.headerBtnText}</Link>
            </div>
            <div className='info-pricing mt-50 hide-mobile'>
              <p className='t-center'>{content.headerOurPrice} <b className='large ml-5 mr-5'><FormattedMessage id="index.ourPrice" /></b></p>
              <span className='versus'>{content.headerVs}</span>
              <p className='t-center'><s>{content.headerClinicPrice}</s> <s className='ml-5 mr-5'><b><FormattedMessage id="index.clinicPrice" /></b></s></p>
            </div>
          </div>
          <Image url={media(content.headerGuaranteeImage)} alt={content.headerGuaranteeImageAlt} className='stamp' />
        </div>
      </div>
      <div className='section-compare-pricing fvw hide-desktop'>
        <div className='content-wrapper'>
          <div className='info-pricing'>
            <p className='t-center'>{content.headerOurPrice} <b className='large ml-5 mr-5'><FormattedMessage id="index.ourPrice" /></b></p>
            <span className='versus'>{content.headerVs}</span>
            <p className='t-center'><s>{content.headerClinicPrice}</s> <s className='ml-5 mr-5'><b><FormattedMessage id="index.clinicPrice" /></b></s></p>
          </div>
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  content: PropTypes.object.isRequired
};

export default Hero;